import { Checkbox } from "@mui/material";
import { ProposalProduct } from "generated/graphql";
import useToggleProposalProductOptionality from "hooks/proposals/useToggleProposalProductOptionality";
import useBooleanToggle from "hooks/useBooleanToggle";
import { ChangeEvent } from "react";

const ToggleProposalProductOptionality = ({
  id,
  isOptional,
  disabled = false,
}: {
  id: ProposalProduct["id"];
  isOptional: boolean;
  disabled?: boolean;
}) => {
  const [value, toggle] = useBooleanToggle(isOptional);
  const [toggleProposalProductOptionality] = useToggleProposalProductOptionality();

  const handleToggle = (e: ChangeEvent<HTMLInputElement>) => {
    toggle();
    toggleProposalProductOptionality({ variables: { id, isOptional: e.target.checked } });
  };

  return (
    <Checkbox
      sx={{
        background: "white",
        borderRadius: 2,
        padding: 0,
      }}
      checked={value}
      onChange={handleToggle}
      onClick={(e) => e.stopPropagation()}
      disabled={disabled}
    />
  );
};

export default ToggleProposalProductOptionality;
